/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, camelcase */
import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

export const MFA_STATUS_TYPE_TO_MESSAGE = {
  THIRDPARTY: 'INTEGRATION.THIRDPARTY',
}

export const formatMfaStatusType = (type, intl) =>
  MFA_STATUS_TYPE_TO_MESSAGE[type] ? intl.formatMessage({ id: MFA_STATUS_TYPE_TO_MESSAGE[type] }) : type

export const getEmployeeFullName = ({ displayName, firstName, lastName, display_name, first_name, last_name }) => {
  if (display_name || first_name || last_name) return display_name || `${first_name} ${last_name}` // prettier-ignore
  if (displayName  || firstName  || lastName ) return displayName  || `${firstName } ${lastName }` // prettier-ignore
  return ''
}

export const formatEmployeeColumn = (cell, row, onClick) => (
  <span className="btn font-regular-hover pl-0" onClick={onClick}>
    {getEmployeeFullName(row)}
  </span>
)

export const formatEmployeeEmailColumn = ({ row, onClick }) => (
  <div className="customAlignment">
    <div>
      {row.enabled === false && (
        <OverlayTrigger
          placement="top-start"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip id="info-tooltip">
              <FormattedMessage id="ENGAGE.SUSPENDED_USER" />
            </Tooltip>
          }
        >
          <span className="suspended">
            <i className="fa fa-ban" />
          </span>
        </OverlayTrigger>
      )}

      <span className="btn font-regular-hover pl-0" onClick={onClick}>
        {getEmployeeFullName(row)}
      </span>
    </div>
    <div>
      <span
        className="btn font-regular-hover p-0 tblGrey email"
        onClick={() => {
          navigator.clipboard.writeText(row.email)
        }}
      >
        {row.email}
        <img className="copyEmail" src="/media/table/copy.png" alt="copy email" />
      </span>
    </div>
  </div>
)

export const formatSimpleColumn = (cell, row, key) => <span className=" pl-0"> {row[key]}</span>

const renderTooltip = (props) => (
  <Tooltip id="duo-tooltip" {...props}>
    The number of failed Duo authentication exceed the lockout threshold defined in the Lockout and Fraud settings. This
    status is only visible while an account is locked out, and cannot be manually set by an admin.
  </Tooltip>
)

const mfaStatusDotAndName = (row) => (
  <>
    <div className={`duo${row?.mfaStatus?.status}`} />
    {row?.mfaStatus?.status && <FormattedMessage id={`INTEGRATION.${row?.mfaStatus?.status}`} />}
  </>
)

const mfaStatusTooltipRender = (row, intl, placement = 'top') => (
  <OverlayTrigger
    placement={placement}
    delay={{ show: 250, hide: 400 }}
    overlay={row?.mfaStatus?.status === 'LOCKED_OUT' ? renderTooltip : <div />}
  >
    <span>
      {row.mfaStatus?.statusList?.map((i, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="px-2" key={index}>
          <span className="p-0 tblGrey">
            {formatMfaStatusType(i.type, intl)}
            &nbsp;
            {i.status && ` - ${intl.formatMessage({ id: `GENERAL.${i.status}` })}`}
          </span>
        </div>
      ))}
    </span>
  </OverlayTrigger>
)

/**
 * Used for putting the mfa status result on one line
 * @param {*} row
 * @param {*} intl
 */
export const formatMfaStatusInLine = (row, intl) => (
  <div>
    <span>{mfaStatusDotAndName(row)}</span>
    {mfaStatusTooltipRender(row, intl, 'top')}
  </div>
)

export const formatMfaStatusFullDetailsColumn = (cell, row, intl) => (
  <div className="wrapperUnit">
    <div>
      <span className="pl-0">{mfaStatusDotAndName(row)}</span>
    </div>
    <div>{mfaStatusTooltipRender(row, intl, 'left')}</div>
  </div>
)

const renderMfaConfigurationTooltip = (props, affectedByCAs, onClick) => (
  <Tooltip id="mfaConfig-tooltip" {...props}>
    <div className="MfaConfigurationTooltip">
      {affectedByCAs.map((i, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={onClick ? 'btn font-regular-hover p-0  ' : 'p-0  '}
          onClick={() => {
            document.body.click()
            // eslint-disable-next-line no-unused-expressions
            onClick && onClick(i)
          }}
        >
          {i.policyName}
        </div>
      ))}
    </div>
  </Tooltip>
)

export const formatMfaConfigurationColumn = (cell, row, onClick, intl) => (
  <div key={row?.id}>
    <div>
      <span className={`pl-0 ${row?.mfaConfigurations?.configurationStatus === 'NOT_CONFIGURED' && 'tblGrey'}`}>
        {row?.mfaConfigurations?.configurationStatus &&
          intl.formatMessage({
            id: `INTEGRATION.${row?.mfaConfigurations?.configurationStatus}`,
          })}
      </span>
    </div>
    {['CAP', 'DUO', 'DUO_AND_CAP', 'PER_USER_MFA_AND_CAP'].includes(row?.mfaConfigurations?.configurationStatus) && (
      <div className="noLineHeight">
        <OverlayTrigger
          rootClose
          placement="bottom"
          trigger="click"
          delay={{ show: 250, hide: 400 }}
          props={{ affectedByCAs: row.mfaConfigurations?.affectedByCAs }}
          overlay={(p) => renderMfaConfigurationTooltip(p, row?.mfaConfigurations?.affectedByCAs, onClick)}
        >
          <span className="btn font-regular-hover p-0 tblGrey">
            {row?.mfaConfigurations?.affectedByCAs.length} {intl.formatMessage({ id: 'INTEGRATION.CONDITIONALPOLICY' })}
          </span>
        </OverlayTrigger>
      </div>
    )}
  </div>
)

export const formatMfaIntegrationEnabled = (cell, row, key) => {
  const isEnabled = row[key]?.find(
    (integration) => integration.IntegrationApplication?.application_name === 'Office365',
  )
  return <span className="  pl-0"> {isEnabled ? 'Yes' : 'No'}</span>
}

const addToOptionsMap = (optionsMap, value) => {
  // eslint-disable-next-line no-param-reassign
  optionsMap[value] = optionsMap[value] ? optionsMap[value] + 1 : 1
}

export const getTableOptions = (data, dataField) => {
  const optionsMap = {}
  data?.forEach((item) => {
    if (Array.isArray(item?.[dataField])) {
      item?.[dataField]?.forEach((value) => {
        optionsMap[value] = optionsMap[value] ? optionsMap[value] + 1 : 1
      })
    } else if (item?.[dataField]) {
      addToOptionsMap(optionsMap, item?.[dataField])
    }
  })
  return Object.entries(optionsMap).map((entry) => ({
    label: entry[0],
    value: entry[0],
    count: entry[1],
  }))
}

export const employeeNameSort = (a, b, order, dataField, rowA, rowB) => {
  const nameA = getEmployeeFullName(rowA)
  const nameB = getEmployeeFullName(rowB)
  if (order === 'asc') {
    return nameB.localeCompare(nameA)
  }
  return nameA.localeCompare(nameB) // desc
}

export const getAuthMethodsMap = (intl) => ({
  authenticationApp: {
    label: intl.formatMessage({ id: 'SECURE.AUTHENTICATION_APP' }),
    color: '#fd7e14',
  },
  phoneSms: {
    label: intl.formatMessage({ id: 'SECURE.PHONE_SMS' }),
    color: '#985c26',
  },
  securityKey: {
    label: intl.formatMessage({ id: 'SECURE.SECURITY_KEY' }),
    color: '#e83e8c',
  },
  other: {
    label: intl.formatMessage({ id: 'GENERAL.OTHER' }),
    color: '#6f42c1',
  },
  microsoftAuthenticatorAuthenticationMethod: {
    label: intl.formatMessage({
      id: 'SECURE.AUTHUTHENTICATION_METHODS.MSFT_AUTHENTICATION_APP',
    }),
    color: '#41bbc5',
  },
  phoneAuthenticationMethod: {
    label: intl.formatMessage({ id: 'SECURE.AUTHUTHENTICATION_METHODS.PHONE' }),
    color: '#fb899b',
  },
  fido2AuthenticationMethod: {
    label: intl.formatMessage({ id: 'SECURE.AUTHUTHENTICATION_METHODS.FIDO2' }),
    color: '#44dd39',
  },
  alternateMobilePhoneAuthenticationMethod: {
    label: intl.formatMessage({
      id: 'SECURE.AUTHUTHENTICATION_METHODS.ALTERNATE_MOBILE',
    }),
    color: '#3e3abc',
  },
  officePhoneAuthenticationMethod: {
    label: intl.formatMessage({ id: 'SECURE.AUTHUTHENTICATION_METHODS.OFFICE_PHONE' }),
    color: '#ae102d',
  },
  softwareOneTimePasscodeAuthenticationMethod: {
    label: intl.formatMessage({
      id: 'SECURE.AUTHUTHENTICATION_METHODS.SOFT_ONETIME_PASS',
    }),
    color: '#11793a',
  },
  hardwareOneTimePasscodeAuthenticationMethod: {
    label: intl.formatMessage({
      id: 'SECURE.AUTHUTHENTICATION_METHODS.HARD_ONETIME_PASS',
    }),
    color: '#ed4ade',
  },
  windowsHelloForBusinessAuthenticationMethod: {
    label: intl.formatMessage({
      id: 'SECURE.AUTHUTHENTICATION_METHODS.WINDOWS_HELLO',
    }),
    color: '#c8f148',
  },
  emailAuthenticationMethod: {
    label: intl.formatMessage({ id: 'SECURE.AUTHUTHENTICATION_METHODS.EMAIL' }),
    color: '#a4528d',
  },
  softwareOathAuthenticationMethod: {
    label: intl.formatMessage({ id: 'SECURE.AUTHUTHENTICATION_METHODS.SOFT_OATH' }),
    color: '#f15842',
  },
  temporaryAccessPassAuthenticationMethod: {
    label: intl.formatMessage({ id: 'SECURE.AUTHUTHENTICATION_METHODS.TAP' }),
    color: '#8a2df3',
  },
  passwordlessMicrosoftAuthenticatorAuthenticationMethod: {
    label: intl.formatMessage({
      id: 'SECURE.AUTHUTHENTICATION_METHODS.PASSWORDLESS',
    }),
    color: '#0E9CE3',
  },

  // preserving the old authentication methods to have a smooth transition in the release day, otherwise they will all appear gray until the next ingestion
  // the methods below can be deleted later in the next release
  password: {
    label: 'Password',
    color: '#8a2df3',
  },
  authenticator: {
    label: 'Authenticator',
    color: '#41bbc5',
  },
  phone: {
    label: 'Phone',
    color: '#fb899b',
  },
  windowshello: {
    label: 'Windows Hello',
    color: '#c8f148',
  },
  DUO: {
    label: 'DUO',
    color: '#f15842',
  },
})

export const getAutheticationTypeFormatter = (intl) => (value) => getAuthMethodsMap(intl)[value]?.label || value
